function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M49.5 25c0 13.531-10.969 24.5-24.5 24.5S.5 38.531.5 25 11.469.5 25 .5 49.5 11.469 49.5 25z",
  fill: "#fff",
  stroke: "#3E3E3F"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M25.003 36.17a2.158 2.158 0 01-1.546-.612 2.222 2.222 0 01-.7-1.516h4.491a2.222 2.222 0 01-.7 1.516 2.158 2.158 0 01-1.545.613zm-4.434-4.2v-1.34h8.867v1.34h-8.867zm.088-3.383c-1.186-.797-2.12-1.779-2.8-2.945-.68-1.167-1.021-2.47-1.021-3.909 0-2.236.802-4.156 2.406-5.76s3.524-2.406 5.76-2.406c2.237 0 4.157.802 5.761 2.406s2.406 3.524 2.406 5.76c0 1.44-.34 2.742-1.02 3.909-.681 1.166-1.614 2.148-2.8 2.945h-8.692zm.466-1.341h7.759a6.615 6.615 0 002.187-2.392 6.469 6.469 0 00.788-3.12c0-1.887-.671-3.5-2.013-4.842-1.341-1.342-2.955-2.013-4.841-2.013-1.887 0-3.5.671-4.842 2.013-1.342 1.341-2.013 2.955-2.013 4.841 0 1.109.263 2.149.788 3.121a6.615 6.615 0 002.187 2.392z",
  fill: "#3E3E3F"
});

function SvgLightbulb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    fill: "none"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "89a38df543444fc8af0bd7a1ab2c6ccd.svg";
export { SvgLightbulb as ReactComponent };